import { Injectable } from '@angular/core';
import * as api from '../../api';
import { SortFilterDto } from "../../api/model/sortFilterDto";

export enum OrderActiveStatusEnum {
    Any,
    Active,
    Discontinued
}

@Injectable()
export class ResidentsService {

    constructor(
        private residentsApi: api.ResidentService
    ) {}

    getResidentInfo(resId: string, facId: string) {
        return this.residentsApi.residentGetPersonalInfo(facId, resId);
    }

    getResidentMedOrders(resId: string, facId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued') {
        return this.residentsApi.residentGetMedOrders(facId, resId, orderActiveStatus);
    }

    getResidentNonMedOrders(resId: string, facId: string, orderActiveStatus: 'Any' | 'Active' | 'Discontinued') {
        return this.residentsApi.residentGetNonMedOrders(facId, resId, orderActiveStatus);
    }

    getResidentPayInfo(resId: string, facId: string) {
        return this.residentsApi.residentGetPaymentInfo(facId, resId);
    }

    getResidentProfileStats(resId: string, facId: string) {
        return this.residentsApi.residentGetProfileStats(facId, resId);
    }


    getResidents(facilityId: string, sortFilterDto: SortFilterDto) {
        return this.residentsApi.residentGetResidentDetails(facilityId, sortFilterDto)
    }

    getResidentsDetailsByPayorType(facilityId: string){
        return this.residentsApi.residentGetResidentDetailsByPayorType(facilityId);
    }
}